import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";

import { getStripe, getStripeEnvironment } from "@/lib/stripe";
import { createApplicationCheckout } from "@/utils/payments.functions";

export function ApplicationCheckout({
  applicationId,
  returnUrl,
  couponCode,
}: {
  applicationId: string;
  returnUrl?: string;
  couponCode?: string;
}) {
  const fetchClientSecret = async (): Promise<string> => {
    const result = await createApplicationCheckout({
      data: {
        applicationId,
        returnUrl: returnUrl || window.location.href,
        environment: getStripeEnvironment(),
        ...(couponCode ? { couponCode } : {}),
      },
    });
    if ("error" in result) throw new Error(result.error);
    if (!result.clientSecret) throw new Error("No client secret returned");
    return result.clientSecret;
  };


  return (
    <div id="checkout" className="mt-6">
      <EmbeddedCheckoutProvider stripe={getStripe()} options={{ fetchClientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
